/**
 * 排出別品目単価
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/suppliers/sales_item_prices`
const supplier_sales_item_price = {
  namespaced: true,
  actions: {
    /**
     * 排出別売上品目単価一覧の取得
     * @param dispatch
     * @param commit
     * @param state
     * @param supplier_id { Number } 事業者ID
     * @param supplier_type { String } 事業者種別
     * @param reference_date { String } 表示基準日
     * @param sales_item_name { String } 売上品目名
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { supplier_id, supplier_type, reference_date, sales_item_name }) {
      let params = { supplier_id: supplier_id, supplier_type: supplier_type, reference_date: reference_date, sales_item_name: sales_item_name }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    /**
     * 排出別売上品目単価一覧の登録
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
  mutations: {},
}

export default supplier_sales_item_price
